module.exports = __webpack_public_path__ + "img/logo-topcv.svg?version=2982c2d3";